
import { addVariousTags, deleteVariousTags, getVariousTagsList, modifyVariousTags } from '@/api/allTags';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'SettingTemplateReportedVariousTags',
  components: {

  }
})
export default class extends Vue { // 东改
  private tableData = []
  private addVariousTagsVisible = false
  private formVariousTags:any = {
    name: '',
    type: {}
  }
  private rulesVariousTags:any = {
    name: [
      { required: true, message: '请输入预设填写内容', trigger: 'blur' },
      { pattern: /^((?!").)*$/, message: '请忽填写英文状态下的双引号', trigger: 'blur' }
    ]
  }
  private typeOptions: any = [{
    value: '5',
    label: '上报原因',
    visibility: true
  },
  // {
  //   value: '4',
  //   label: '维修备注',
  //   visibility: true
  // },
  {
    value: '6',
    label: '维修小结',
    visibility: true
  },
  {
    value: '7',
    label: '巡检描述',
    visibility: !!(UserModule.getCompany as any).check_module
  }]
  private activeName = 'all'
  // 分页处理
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.getVariousTagsList();
  }
  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getVariousTagsList();
  }

  private handleClick() {
    if (this.activeName === 'reason') {
      this.formSearch.type = '5';
      this.getVariousTagsList();
    } else if (this.activeName === 'summary') {
      this.formSearch.type = '6';
      this.getVariousTagsList();
    } else if (this.activeName === 'describe') {
      this.formSearch.type = '7';
      this.getVariousTagsList();
    } else {
      this.formSearch.type = '';
      this.getVariousTagsList();
    }
  }

  // life circle
  created() {
    this.getVariousTagsList();
  }
  private getType(row:any) {
    let text = '';
    switch (parseInt(row.type)) {
      case 1:
        text = '任务描述';
        break;
      case 2:
        text = '补充进度';
        break;
      case 3:
        text = '图片';
        break;
      case 4:
        text = '维修备注';
        break;
      case 5:
        text = '上报原因';
        break;
      case 6:
        text = '维修小结';
        break;
      case 7:
        text = '巡检描述';
        break;
    }
    return text;
  }
  // 规则-列表
  private getVariousTagsList() {
    let VariousTagsParam: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    VariousTagsParam.type = this.formSearch.type;
    getVariousTagsList(VariousTagsParam).then(res => {
      if (res.data) {
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
      } else {
        this.tableData = [];
      }
    }).catch((err: any) => {
      let msg = err.msg;
      this.pagination.total = 0;
      this.pagination.currentPage = 1;
    });
  }
  // 添加上报原因
  private clickToAddVariousTags() {
    this.formVariousTags = {}; // 初始置空
    this.addVariousTagsVisible = true;
  }
  private AddVariousTagsHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        if (this.formVariousTags.id) {
          this.editVariousTagsRequest();
        } else {
          this.addVariousTagsRequest();
        }
      } else {
        return false;
      }
    });
  }
  private addVariousTagsRequest() {
    if (!this.formVariousTags.type || !this.formVariousTags.type.value) {
      this.showErrorMsg('请选择类型');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formVariousTags.name,
      type: this.formVariousTags.type.value
    };
    addVariousTags(params).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.getVariousTagsList();
      this.addVariousTagsVisible = false;
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 删除原因
  private deleteVariousTags(val: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      tags_id: val.id,
      type: val.type
    };
    deleteVariousTags(params).then(res => {
      this.getVariousTagsList();
      this.showSuccessMsg('删除成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }
  // 编辑原因
  private editVariousTagsHandle(val: any) {
    this.formVariousTags.name = val.name;
    this.formVariousTags.id = val.id;
    this.$set(this.formVariousTags.type, 'label', this.getType(val));
    this.$set(this.formVariousTags.type, 'value', val.type);
    this.addVariousTagsVisible = true;
  }
  private editVariousTagsRequest() {
    let params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formVariousTags.name,
      tags_id: this.formVariousTags.id,
      type: this.formVariousTags.type.value
    };
    modifyVariousTags(params).then(res => {
      this.getVariousTagsList();
      this.addVariousTagsVisible = false;
      this.showSuccessMsg('修改成功');
    }).catch((err: any) => {
      this.showErrorMsg(err.msg);
    });
  }

  private formSearch: any ={
    type: ''
  }
  // private handleSearch() {
  //   this.getVariousTagsList();
  // }

  // private handleClear() {
  //   this.formSearch.type = '';
  //   this.getVariousTagsList();
  // }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
